import React, {Component} from 'react';
import _ from 'lodash';
import {Control, Form} from "react-redux-form";
import ProjectDataForm from "./widgets/project_data_form";
import GoalSelectorWidget from "./widgets/goal_selector";
import GoalsModal from "./widgets/project_goals_modal_widget";
import ModIProject from "./widgets/project_mod-i_goals_list_widget";
import ModIIProject from './widgets/project_mod-ii_goals_list_widget';
import ModIIIProject from "./widgets/project_mod-iii_goals_list_widget";

class ProjectGoalEditForm extends Component {
	render() {
		const {registry, permissions, modality, state, municipality, proigualdadGoals, municipalities, goals, fetching, resource_concepts, directories} = this.props;
		let rev = registry.revision ? registry.revision.body : undefined;
		let registryDisabled = this._permissionField();
		const pc = _.find(permissions, (o) => {
			return o === 'Create'
		});

		return <div className="columns">
			<div className="column">
				<Form
					model="project.registry.data"
					onSubmit={(project) => this._handleSubmit(project)}
					onSubmitFailed={(error) => this.props.setSystemNotification('¡Oh no!', 'Hay errores en el formulario', 'danger')}
				>

					<GoalsModal
						active={this.state.goalsShow}
						closeModal={this._toggleModal}
						modality={modality}
						state={state}
						municipality={municipality}
						fetching={proigualdadGoals.isFetching}
						proigualdad={proigualdadGoals.list}
						pages={proigualdadGoals.pages}
						pageChange={this._pageChange}
					/>

					{modality === 'modalidad-i' &&
					<div className="field is-grouped is-grouped-right">
						<div className="control">
							<button type="button" className="button is-primary" onClick={() => this._openGoalsModal()}>
								Metas personalizadas
							</button>
						</div>
					</div>}

					<ProjectDataForm
						revision={rev}
						fetching={registry.isFetching}
						data={registry.data}
						disabled={registryDisabled}
					/>

					<GoalSelectorWidget
						goals={_.filter(goals, (o) => {return o.modality.slug === modality})}
						modality={modality}
						isDisabled={registryDisabled}
						fetching={fetching}
						canAdd={this._canAddActivities}
						goalAdd={this._addGoal}
					/>

					{modality === 'modalidad-i' &&
					<ModIProject
						editable={registry.editable}
						state={state}
						municipalities={municipalities}
						entities={this.props.entities.list}
						goals={registry.data.project_goals}
						directories={directories}
						allgoals={goals}
						change={this.props.change}
						add={this.props.add}
						remove={this.props.remove}
						fetchMunicipalities={this.props.fetchMunicipalities}
						revision={registry.revision && registry.revision.body && registry.revision.body.goals ? registry.revision.body.goals : undefined}
						resources={resource_concepts}
						projectTotal={registry.data.amounts}
					/>}

					{modality === 'modalidad-ii' &&
					<ModIIProject
						editable={registry.editable}
						state={state}
						municipalities={municipalities}
						entities={this.props.entities.list}
						goals={registry.data.project_goals}
						directories={directories}
						allgoals={goals}
						change={this.props.change}
						add={this.props.add}
						remove={this.props.remove}
						fetchMunicipalities={this.props.fetchMunicipalities}
						revision={registry.revision && registry.revision.body && registry.revision.body.goals ? registry.revision.body.goals : undefined}
						resources={resource_concepts}
						projectTotal={registry.data.amounts}
					/>}

					{modality === 'modalidad-iii' &&
					<ModIIIProject
						editable={registry.editable}
						state={state}
						municipalities={municipalities}
						entities={this.props.entities.list}
						goals={registry.data.project_goals}
						directories={directories}
						allgoals={goals}
						change={this.props.change}
						add={this.props.add}
						remove={this.props.remove}
						fetchMunicipalities={this.props.fetchMunicipalities}
						revision={registry.revision && registry.revision.body && registry.revision.body.goals ? registry.revision.body.goals : undefined}
						resources={resource_concepts}
						projectTotal={registry.data.amounts}
					/>}

					<br/>
					<div className="columns is-borderless">
						<div className="column">
							<div className="field is-grouped is-grouped-right">
								<div className="control">
									<button type="button" className="button is-large" onClick={() => this.props.history.goBack()}> Regresar
									</button>
								</div>

								{pc &&
								<div className="control">
									<Control.button
										model="project.registry.data"
										className="button is-large is-primary"
										disabled={!registry.editable}>
										Guardar
									</Control.button>
								</div>}
							</div>
						</div>
					</div>

					<p className="has-text-grey has-text-right is-small">
						Los campos indicados con <span className="small has-text-danger">*</span> son obligatorios.
					</p>

				</Form>
			</div>
		</div>
	}

	constructor(props) {
		super(props);
		this.state = {
			canAdd: false,
			goalsShow: false
		}
		this._canAddActivities = this._canAddActivities.bind(this);
		this._addGoal = this._addGoal.bind(this);
		this._openGoalsModal = this._openGoalsModal.bind(this);
		this._toggleModal = this._toggleModal.bind(this);
		this._pageChange = this._pageChange.bind(this);
	}

	_handleSubmit(values) {
		let {modality, state, municipality} = this.props;
		this.props.saveRegistry(modality, state, municipality, values);
	}

	_permissionField() {
		let {registry} = this.props;
		let response = false;
		let editable = registry.editable;
		let registryRevision = !_.isEmpty(registry.revision) ? registry.revision.body : undefined;

		if (!_.isEmpty(registryRevision) && !registry.isFetching) {
			let allow = registryRevision.allow_edit === 'true' ? true : false;
			if (editable && allow) {
				response = false;
			} else {
				response = true;
			}
		} else if (editable && !registry.isFetching) {
			response = false;
		} else {
			response = true;
		}

		return response;
	}

	_openGoalsModal() {
		this.props.projectProigualdadGoals(this.props.proigualdadGoals.pages.current, this.props.modality, this.props.state, this.props.municipality);
		return this.setState({
			goalsShow: true
		})
	}

	_pageChange(page) {
		this.props.projectProigualdadGoals(page, this.props.modality, this.props.state, this.props.municipality);
	}

	_toggleModal() {
		return this.setState({goalsShow: !this.state.goalsShow});
	}

	_addGoal(item) {
		let {goals} = this.props;
		let goal = _.find(goals, {id: _.toInteger(item)});
		if(goal !== undefined) {
			let repeated = _.findKey(this.props.registry.data.project_goals, {proigualdad_goal_id: _.toInteger(goal.id)});
			if (repeated === undefined) {
				let goalObj = {
					code: _.join([goal.id, goal.type], '.'),
					geographic_area: undefined,
					name: goal.name,
					proigualdad_goal_id: _.toInteger(goal.id),
					resource_concept_id: undefined,
					activities: [],
					total: 0,
					actors: [],
					conagoClauses: [],
					mandatory: goal.mandatory
				}

				this.props.add('project.registry.data.project_goals', goalObj);
				return this._canAddActivities();
			} else {
				alert('No se pueden duplicar metas');
			}
		} else {
			alert('No pudimos encontrar la meta que deseas agregar');
		}
	}

	_canAddActivities(value) {
		let {goals} = this.state;
		if (goals) {
			let currGoal = _.toInteger(value !== 0 ? _.toInteger(value) : undefined);
			let key = _.findKey(goals, o => o.id === currGoal);
			let canAdd = (key === undefined || key < 0) ? false : true;
			return this.setState({canAdd: canAdd});
		}
	}
}

export default ProjectGoalEditForm;


// WEBPACK FOOTER //
// ./src/elements/project/registry.jsx